export const EVENT_PRESS_ENTER_TO_ADVANCED_SEARCH = 'press_enter_to_advanced_search';
export const EVENT_PRESS_ESCAPE_IN_COMMAND_PALETTE = 'press_escape_in_command_palette';
export const EVENT_CLICK_OUTSIDE_OF_COMMAND_PALETTE = 'click_outside_of_command_palette';
export const EVENT_PRESS_GREATER_THAN_IN_COMMAND_PALETTE = 'press_greater_than_in_command_palette';
export const EVENT_PRESS_AT_SYMBOL_IN_COMMAND_PALETTE = 'press_at_symbol_in_command_palette';
export const EVENT_PRESS_COLON_IN_COMMAND_PALETTE = 'press_colon_in_command_palette';
export const EVENT_PRESS_FORWARD_SLASH_IN_COMMAND_PALETTE =
  'press_forward_slash_in_command_palette';
export const LABEL_COMMAND_PALETTE = 'command_palette';
